import { Controller } from "@hotwired/stimulus"

// Shared by the three credential setup dialogs (Zoho, custom REST, cloud storage). Not a
// registered controller: the glob in index.js only picks up *_controller.js files.
export default class CredentialFormBase extends Controller {
  // Turbo streams the <dialog> in closed; each form opens it once its own state is set.
  openDialog() {
    if (this.element.tagName === "DIALOG" && !this.element.open) this.element.showModal()
  }

  close() { this.element.close() }

  credentialInput(key) { return this.element.querySelector(`[name="credentials[${key}][value]"]`) }

  // Hidden fields must not be submitted, so they are disabled along with being hidden.
  toggleSection(section, visible) {
    section.classList.toggle("hidden", !visible)
    section.querySelectorAll("input, select, textarea").forEach(input => { input.disabled = !visible })
  }

  // Same class names as credential_choice_class in Organizations::ApiCredentialsHelper.
  markChoice(element, selected) {
    element.setAttribute("aria-pressed", selected)
    for (const name of ["border-indigo-600", "bg-indigo-50", "ring-1", "ring-indigo-600"]) element.classList.toggle(name, selected)
    for (const name of ["border-gray-300", "bg-white"]) element.classList.toggle(name, !selected)
  }

  async copyValue(event) {
    const button = event.currentTarget
    const input = this.element.querySelector(`#${button.dataset.copySource}`)
    const original = button.innerHTML
    try {
      await navigator.clipboard.writeText(input.value)
      button.textContent = "Copied"
    } catch {
      input.focus()
      input.select()
      button.textContent = "Select and copy"
    }
    setTimeout(() => { button.innerHTML = original }, 2000)
  }
}
